<template>
    <div class="users_list mt-3">
        <ul class="user_list_to_insert">
            <li v-for="(item,index) in u_list" @click.prevent="set_active(item,index)"  :class="user_class(item)" class="border cursor-pointer shadow-1 mt-1 mb-2">
                <user_block
                    :show_vacation=true
                    :key="item.id"
                    :user=item padding_class="pt-2 pl-2 pb-1">
                </user_block>
            </li>
        </ul>
    </div>
</template>

<script>

    import {createHelpers} from 'vuex-map-fields';
    const {mapFields} = createHelpers({
        getterType: 'users_filter/getUfilterField',
        mutationType: 'users_filter/updateUfilterField',
    });

    import user_block from "../user/user_block/user_block.vue";

    export default {
        name: "users_list",
        props : ['users'],
        components :  {
            user_block
        },

        data () {
            return {
              u_list : this.users
            }
        },

        created () {
            EventBus.$on('check_list',this.activate_list);
        },

        methods: {
            activate_list(flag) {
                flag = flag.active;
                let tmp = this.active_users_list;

                for (let j = this.u_list.length - 1; j >= 0; j -= 1) {
                    let is_find = false;

                    for (let i = tmp.length - 1; i >= 0; i -= 1) {
                        if (parseInt(tmp[i].id) === parseInt(this.u_list[j].id)) {
                            if (flag === false) {
                                tmp.splice(i, 1);
                            }
                            is_find = true;
                        }
                    }

                    if (is_find === false) {
                        if (flag === true && !this.is_excluded(this.u_list[j])) {
                            tmp.push(this.u_list[j]);
                        }
                    }
                }


                if(tmp.length > 0) {
                    tmp.reverse();
                }
            },

            set_active(item,index) {
                if (this.is_excluded(item)) {
                    return;
                }
                
                // просто меняем значение
                item.is_active = !item.is_active;
                // для массива достаточно заменить по индексу
                this.u_list[index] = { ...item };
                this.store_cache(item);
            },

            store_cache(item) {
                let is_find = false;
                let tmp = this.active_users_list;
                //https://gist.github.com/chad3814/2924672
                for (let i = tmp.length - 1; i >= 0; i -= 1) {
                    if (tmp[i].id === item.id) {
                        tmp.splice(i, 1);
                        is_find = true;
                    }
                }

                if(is_find === false) {
                    tmp.push(item);
                }
            },

            user_class(item) {

               if(this.is_excluded(item)){
                   return 'disabled';
               }

               if(this.is_active(item)) {
                   return 'active bg-selected-50';
               }
            },

            is_active (item) {
                if(this.active_users_list.length > 0) {
                    for (let i = this.active_users_list.length - 1; i >= 0; i -= 1) {
                        if (parseInt(this.active_users_list[i].id) === parseInt(item.id)) {
                            return true;
                        }
                    }
                }

                return false;
            },


            is_excluded (item) {
                if(this.exclude_users.length > 0) {
                    for (let i = this.exclude_users.length - 1; i >= 0; i -= 1) {
                        if (parseInt(this.exclude_users[i].id) === parseInt(item.id)) {
                            return true;
                        }
                    }
                }
                return false;
            },


            user_company (item) {
                if(this.obj_to_null(item) != null) {
                    return item.company + ", " + item.department
                }
            },
        },
        computed: {
            
            ...mapFields([
                'active_users',
                'exclude'
            ]),
            
            active_users_list : {
                get() {
                    return this.active_users;
                },
                set(arr) {
                    this.$store.dispatch('users_filter/SET_ACTIVE_USERS_LIST', arr);
                }
            },
            
            
            
            exclude_users () {
                return this.exclude;
            }

        },

        watch: {
            users(value) {
                this.u_list = value;
            }
        },

        beforeDestroy() {
            EventBus.$off('check_list',this.activate_list);
        }

    }
</script>

<style scoped>
    .users_list {
        max-height: 75vh;
        overflow: auto;
    }

    .user_list_to_insert {
        margin-left: 0;
        padding-left: 0;
        width:98%;
    }


</style>
